import { render } from "./designListShow.vue?vue&type=template&id=5932ba25"
import script from "./designListShow.vue?vue&type=script&lang=js"
export * from "./designListShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__